var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02438 4.91016L9.47509 2.94909C9.68627 2.03023 9.79186 1.57081 10.1429 1.35096C10.494 1.13112 10.9554 1.23716 11.8782 1.44925V1.44925C12.801 1.66134 13.2624 1.76739 13.4823 2.11844C13.7021 2.4695 13.5961 2.93091 13.384 3.85372V3.85372C13.1719 4.77654 13.0658 5.23795 12.7148 5.45779C12.3637 5.67764 11.9043 5.57205 10.9855 5.36087L9.02438 4.91016Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02438 12.0293L9.47509 13.9904C9.68627 14.9092 9.79186 15.3686 10.1429 15.5885C10.494 15.8083 10.9554 15.7023 11.8782 15.4902V15.4902C12.801 15.2781 13.2624 15.1721 13.4823 14.821C13.7021 14.47 13.5961 14.0085 13.384 13.0857V13.0857C13.1719 12.1629 13.0658 11.7015 12.7148 11.4817C12.3637 11.2618 11.9043 11.3674 10.9855 11.5786L9.02438 12.0293Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01221 10.3618L3.00001 10.3618C2.0572 10.3618 1.5858 10.3618 1.2929 10.0689C1.00001 9.77603 1.00001 9.30259 1.00001 8.35572V8.35572C1.00001 7.40884 1.00001 6.93541 1.2929 6.64251C1.5858 6.34962 2.05924 6.34962 3.00611 6.34962V6.34962C3.95298 6.34962 4.42642 6.34962 4.71931 6.64251C5.01221 6.93541 5.01221 7.40681 5.01221 8.34962L5.01221 10.3618Z",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11795 4.60471L5.01218 7.14622",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11795 12.3347L5.01218 9.79324",
    stroke: "#8A8A8A",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f807e7c48f5b8d6b158275917398a721.svg";
export { ForwardRef as ReactComponent };